
import AppComponent from "@/views/App/AppComponent";
export default AppComponent;
